export default __webpack_public_path__ + "static/media/Minus.aa3be89d.svg";